let graphicLayer, tilesetLayer, tilesetPlanClip;
let normalShutdown = false; // 标记是否为点击关闭按钮后退出。
export default {
  // inject:['marsMap','marsMeasure'],
  props: ["modelCrop"],
  data() {
    return {
      modelCrop_show: true,
      modelCropValue: 1,
      isFold: false,
      activeBtn: 0, // 被点击(激活)状态的按钮编号。
    };
  },
  methods: {
    adjustModelCrop() {
      let cRes = this.checkInfo();
      if (!cRes) {
        return false;
      }
      tilesetPlanClip.distance = this.modelCropValue;
      // this.$emit('changeModelCrop', this.modelCropValue);
    },
    cropTop() {
      this.activeBtn = 1;
      let cRes = this.checkInfo();
      if (!cRes) {
        return false;
      }
      tilesetPlanClip.type = mars3d.thing.TilesetPlanClip.Type.ZR;
    },
    cropBottom() {
      this.activeBtn = 2;
      let cRes = this.checkInfo();
      if (!cRes) {
        return false;
      }
      tilesetPlanClip.type = mars3d.thing.TilesetPlanClip.Type.Z;
    },
    cropByLine() {
      this.activeBtn = 3;
      let cRes = this.checkInfo();
      if (!cRes) {
        return false;
      }

      let that = this;
      tilesetPlanClip.clear();

      graphicLayer.startDraw({
        type: "polyline",
        maxPointNum: 2,
        style: {
          color: "#007be6",
          opacity: 0.8,
          outline: false,
        },
        success: function(graphic) {
          //绘制成功后回调
          let positions = graphic.positionsShow;
          graphicLayer.clear();

          tilesetPlanClip.positions = positions;
        },
      });
    },
    digIn() {
      this.activeBtn = 4;
      let cRes = this.checkInfo();
      if (!cRes) {
        return false;
      }
      tilesetPlanClip.clear();
      graphicLayer.startDraw({
        type: "polygon",
        style: {
          color: "#007be6",
          opacity: 0.5,
        },
        success: function(graphic) {
          //绘制成功后回调
          let positions = graphic.positionsShow;
          graphicLayer.clear();

          console.log(
            JSON.stringify(mars3d.PointTrans.cartesians2lonlats(positions))
          ); //打印下边界

          tilesetPlanClip.positions = positions;
        },
      });
    },
    cropOutside() {
      this.activeBtn = 5;
      let cRes = this.checkInfo();
      if (!cRes) {
        return false;
      }

      let that = this;
      tilesetPlanClip.clear();

      graphicLayer.startDraw({
        type: "polygon",
        style: {
          color: "#007be6",
          opacity: 0.5,
          clampToGround: true,
        },
        success: function(graphic) {
          //绘制成功后回调
          let positions = graphic.positionsShow;
          graphicLayer.clear();

          tilesetPlanClip.clipOutSide = true;
          tilesetPlanClip.positions = positions;
        },
      });
    },
    clearCrop() {
      this.activeBtn = 6;
      if (tilesetPlanClip) {
        tilesetPlanClip.clear();
      }
      graphicLayer.clear();
    },
    checkInfo() {
      //alert(window.sessionStorage.getItem('currentLayerId'));
      let currentLayerId = window.sessionStorage.getItem("currentLayerId");
      tilesetLayer = this.$GLOBAL.map.getLayerById(currentLayerId);
      if (!tilesetLayer) {
        this.$alert(
          "请先在页面左侧模型目录树里勾选并点击您要裁剪的模型。",
          "友情提示",
          {
            confirmButtonText: "确定",
            type: "warning",
            callback: (action) => {},
          }
        );
        return false;
      }
      //如果切换了模型则更新tilesetPlanClip。
      if (this.currentTilesetLayerId !== currentLayerId) {
        //定位到模型。
        tilesetLayer.flyTo();
        this.currentTilesetLayerId = currentLayerId;
        if (tilesetPlanClip) {
          tilesetPlanClip.clear();
          graphicLayer.clear();
          tilesetPlanClip.layer = tilesetLayer;
        } else {
          tilesetPlanClip = new mars3d.thing.TilesetPlanClip({
            layer: tilesetLayer,
            clipOutSide: false,
            edgeColor: Cesium.Color.GREY,
            edgeWidth: 2.0,
            distance: this.modelCropValue,
          });
          this.$GLOBAL.map.addThing(tilesetPlanClip);
        }
      }
      return true;
    },
    modelCropBox_close() {
      this.clearCrop();
      normalShutdown = true;
      // this.modelCrop_show = false;
      this.$emit("modelCropBox_close");
    },
    verifyBtnIndex(index) {
      if (this.activeBtn === index) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.$message({
      message: "同时只能对单个模型进行裁剪操作，请先选中模型再裁剪哦。",
      offset: 100,
      showClose: true,
      duration: 2300,
    });

    if (!graphicLayer) {
      graphicLayer = new mars3d.layer.GraphicLayer();
      this.$GLOBAL.map.addLayer(graphicLayer);
    }

    if (this.modelCrop || this.modelCrop === 0) {
      this.modelCropValue = this.modelCrop;
    }
    let cRes = this.checkInfo();
    if (!cRes) {
      return false;
    }
  },
  destroyed() {
    //this.$GLOBAL.map.removeLayer(tilesetLayer,true);

    //this.$GLOBAL.map.removeLayer(tilesetLayer,true);//测试模型时用
    if (!normalShutdown) {
      this.clearCrop();
    }
    this.$GLOBAL.map.removeLayer(graphicLayer, true);
    this.$GLOBAL.map.removeThing(tilesetPlanClip, true);
    graphicLayer = null;
    tilesetPlanClip = null;
  },
};
